import { default as api } from 'config/frontApiConf.js';

export const addRatingService = async (data) => {
	try {
		let result = await api.post(`/customer/add-rating-review`, data);
		return result;
	} catch (error) {
		return error;
	}
};
